import React from "react";
import styles from "./TableHeader.module.css";
import { NEXT_SORT_MAP, SORT } from "../constants";
import { Button } from "@justworkshr/milo-core";
import { SortIcon } from "../SortIcon";

interface TableHeaderProps {
  headers: {
    key: string;
    label: string;
    isSortable: boolean;
  }[];
  sortBy: string;
  sortDirection: string;
  onSort: (data: { sortBy: string; sortDirection: string }) => void;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  headers,
  sortBy,
  onSort,
  sortDirection,
}) => {
  const handleClick = (key: string) => {
    const nextDirection =
      key === sortBy ? NEXT_SORT_MAP[sortDirection] : SORT.ASC;

    onSort({ sortBy: key, sortDirection: nextDirection });
  };

  return (
    <thead className={styles.TableHeaderWrapper}>
      <tr>
        {headers.map(({ key, label, isSortable }, index) => {
          const mapKey = `${label}_${index}`;

          if (isSortable) {
            return (
              <th
                key={mapKey}
                className={`${key} ${styles.TableHeaderColumnSortableHeader}`}
              >
                <Button
                  size="sm"
                  type="button"
                  variant="ghost"
                  data-testid={key}
                  className={`${styles.sortButton} ${
                    key === sortBy ? styles.sorted : styles.unsorted
                  }`}
                  onClick={() => handleClick(key)}
                >
                  <span className={styles.TableHeaderLabel}>{label}</span>
                  <SortIcon
                    sortKey={key}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                  />
                </Button>
              </th>
            );
          }

          return (
            <th
              key={mapKey}
              className={`${styles[key]} ${styles.TableHeaderColumnHeaderNotSortable}`}
            >
              <span>{label}</span>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
